import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as styles from './popUp.module.scss';
import React from 'react';

interface Props {
  data: string;
  setPopUp: (value: any) => void;
}

export const PopUp: React.FC<Props> = ({ data, setPopUp }) => {
  return (
    <div className={styles.wrapper}>
      <FontAwesomeIcon icon="xmark" color={'white'} size={'2x'} onClick={setPopUp} />
      <h4 className={styles.message}>{data}</h4>
    </div>
  );
};
